/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.viewer
 * @memberof vef
 */

import * as loader from './loader/index.js';
export { loader };

import * as templates from './loader/index.js';
export { templates };

export * from './Viewer.js';